import { gsap, Expo } from "gsap";

import { ScrollBarHelper } from "exports-loader?exports=ScrollBarHelper!bootstrap/js/src/util/scrollbar";
import { Backdrop } from "exports-loader?exports=Backdrop!bootstrap/js/src/util/backdrop";
import calculHeightHeader from "./calculHeightHeader";
import illustrationHeight from "./illustrationHeight";


const menuToggle = () => {

  const CLASS_NAME_BACKDROP = 'menu-backdrop';
  const navbarToggler = document.querySelectorAll('.toggler-menu-js');
  const header = document.getElementById('header');
  const topBar = document.querySelector('.top--bar');
  const headerWrapper = document.querySelector('.fixed-header');
  const menuSecondaire = document.querySelector('.menu-secondaire');
  const menuSecondaireContent = menuSecondaire.querySelector('.menu-secondaire--content');
  const scrollBar = new ScrollBarHelper();
  const backdrop = new Backdrop({ isAnimated: true, className: CLASS_NAME_BACKDROP,  rootElement : "#wrapper" });
  let headerHeight = calculHeightHeader();
  menuSecondaire.style.paddingTop = headerHeight[0] + 'px';



  const ScrollTo = () => {
    if (window.scrollY < headerHeight[0] + illustrationHeight() + 1) {
      window.scrollTo(0, headerHeight[0] + illustrationHeight() + 1);
    }
  }


  var tl = gsap.timeline();
  tl
    // .to(document.querySelector('html'), {overflow: 'hidden'})

    .to([header, topBar], { 
      backgroundColor: 'rgba(255, 255, 255, 1)',
      duration :  0.5 })
    .add('menuBgApply')
    .to([header, topBar], {
      color: '#000', ease:
        Expo.easeOut,
        duration :  0.5 }, '>-50%')
    .to(menuSecondaire, {
      x: 0, ease:
        Expo.easeOut, 
        duration :  0.8
    }, "menuBgApply") // apres que le menu passe en blanc
    .to(menuSecondaireContent, {
      x: 0, ease:
        Expo.easeOut,
        duration :  0.8
    }, '>-50%')



  tl.pause();


  navbarToggler.forEach((toggler) => {

    toggler.addEventListener('click', (e) => {
      e.preventDefault();
      if (tl.reversed() || tl.paused()) {
        scrollBar.hide();
        ScrollTo();
        tl.play();
      } else {
        tl.reverse();
        scrollBar.reset();
      }

      // juste pour le burger 
      if (headerWrapper.classList.contains('menu-open') === false) {
        headerWrapper.classList.add('menu-open');
        backdrop.show();

      } else {
        headerWrapper.classList.remove('menu-open');
        backdrop.hide();
      }


      const overlay = document.querySelector('.' + CLASS_NAME_BACKDROP);
      if (overlay) {
        overlay.addEventListener('click', (e) => {

          e.preventDefault();
          headerWrapper.classList.remove('menu-open');
          tl.reverse();
          scrollBar.reset();
          backdrop.hide();
        });
      }


    });
  })
}

export default menuToggle;
